import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import AxiosCustom from "../../common/components/apiConfig";
// import { handleNotificationAlertCatch, handleNotificationAlertTrySelect } from '../../common/method/handleNotificationAlert'

export const actionTypes = {
  login: "login [Action]",
  logout: "logout [Action]",
  loginsAsync: "loginsAsync [Action]",
};
const inistiaState = {
  data: {},
  flag:false
};

export const login = (state = inistiaState, { type, payload }) => {
  switch (type) {
    case actionTypes.login:
      return {
        data: payload ,
        flag:true
      };
    case actionTypes.logout:
      return {
        data: {} ,
        flag:false
      };
    default:
      return state;
  }
};

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.login, payload: payload });
 
}

export function* loginWorker() {
  yield takeEvery(actionTypes.loginsAsync, handleWorker);
}
